<template>
  <div class="radar">
    <div class="radar-icon" @click="sendEmail()">
      <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="signal-stream" class="svg-inline--fa fa-signal-stream" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
        <path
          fill="currentColor"
          d="M288 192c-35.38 0-64 28.62-64 63.1s28.62 63.1 64 63.1s64-28.62 64-63.1S323.4 192 288 192zM288 288c-17.62 0-32-14.37-32-31.1s14.38-31.1 32-31.1s32 14.37 32 31.1S305.6 288 288 288zM32 256c0-62.19 24.17-120.7 68.05-164.7C106.3 85.04 106.3 74.92 100 68.67c-6.25-6.187-16.38-6.219-22.62 .0625C27.48 118.8 0 185.3 0 256s27.48 137.2 77.39 187.3C80.52 446.4 84.61 448 88.72 448c4.078 0 8.172-1.562 11.3-4.656c6.25-6.25 6.281-16.37 .0313-22.62C56.17 376.7 32 318.2 32 256zM498.6 68.73c-6.25-6.312-16.38-6.281-22.62-.0625c-6.25 6.25-6.281 16.37-.0313 22.62C519.8 135.4 544 193.8 544 256s-24.17 120.7-68.05 164.7c-6.25 6.25-6.219 16.37 .0313 22.62C479.1 446.4 483.2 448 487.3 448c4.109 0 8.203-1.562 11.33-4.719C548.5 393.2 576 326.7 576 256S548.5 118.8 498.6 68.73zM167.5 132.4c-6.438-6.094-16.56-5.75-22.61 .625C113.4 166.4 96 210.1 96 256s17.36 89.62 48.88 122.1c3.141 3.312 7.375 4.1 11.62 4.1c3.938 0 7.891-1.437 10.98-4.375c6.422-6.062 6.719-16.19 .6406-22.62C142.3 329.6 128 293.8 128 256s14.25-73.62 40.13-100.1C174.2 148.6 173.9 138.4 167.5 132.4zM431.1 133c-6.062-6.375-16.16-6.719-22.61-.625c-6.422 6.062-6.719 16.19-.6406 22.62C433.8 182.4 448 218.3 448 256s-14.25 73.63-40.13 100.1c-6.078 6.437-5.781 16.56 .6406 22.62c3.094 2.937 7.047 4.375 10.98 4.375c4.25 0 8.484-1.687 11.62-4.1C462.6 345.6 480 301.9 480 256S462.6 166.4 431.1 133z"
        ></path>
      </svg>
      <span>Radar</span>
    </div>

    <div class="list-view">
      <div class="list-item" v-for="(x, i) in emails" :key="i">
        <div class="row">
          <div class="column black small">
            <div class="result" v-if="x.status === 'sent'">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="paper-plane-top" class="svg-inline--fa fa-paper-plane-top" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M511.1 255.1c0 12.8-7.625 24.38-19.41 29.41L44.6 477.4c-4.062 1.75-8.344 2.594-12.59 2.594c-8.625 0-17.09-3.5-23.28-10.05c-9.219-9.766-11.34-24.25-5.344-36.27l73.66-147.3l242.1-30.37L77.03 225.6l-73.66-147.3C-2.623 66.3-.4982 51.81 8.72 42.05c9.25-9.766 23.56-12.75 35.87-7.453L492.6 226.6C504.4 231.6 511.1 243.2 511.1 255.1z"></path></svg>
              <span>Sent succesfully</span>
            </div>
            <div class="result red" v-else>
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-exclamation" class="red svg-inline--fa fa-circle-exclamation" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"></path></svg>
              <span>Something went wrong!</span>
            </div>
            <!-- {{ x.status }} -->
          </div>
          <div class="column ">
            {{ x.to }}
          </div>
          <div class="column ">
            {{ x.created_at.toDate().toLocaleDateString() }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { db } from "@/firebase"
import { ref } from "@vue/reactivity"
import { onUnmounted } from "@vue/runtime-core"

const emails = ref([])

const listener = db.collection("email-engine").onSnapshot(snapshot => {
  emails.value = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }))
})

const to = ref("valentine-groze@gmail.com")
const subject = ref("Hoera! Welkom bij CAD-Tekenaar.com")
const title = ref("Hoera! Welkom bij CAD-Tekenaar.com")
const body = ref("Welkom Barrie, Leuk dat je je hebt aangemeld voor ons ...")

const sendEmail = () => {
  db.collection("email-engine").add({
    created_at: new Date(),
    to: to.value,
    subject: subject.value,
    status: "pending",
    content: {
      title: title.value,
      body: body.value
    }
  })
}

onUnmounted(() => listener())
</script>

<style lang="sass" scoped>
.radar
  position: fixed
  z-index: 1000
  inset: 0
  background-color: white
  padding: 2rem 1.8rem

.radar-icon
  display: flex
  align-items: center
  span
    font-size: 18px
    padding-left: 10px
    font-weight: 500

  svg
    height: 2.1rem

.list-view
  padding-top: 2rem
  display: flex
  flex-direction: column
  font-size: 0.9rem
  font-weight: 400
  color: grey
  .list-item
    background-color: rgba(0, 0, 0, 0.03)
    border: 1px solid rgba(0, 0, 0, .04)
    margin-bottom: 4px
    padding: 1rem
    .row
      display: flex
      align-items: center
      .column
        width: 18.5%
        white-space: nowrap
        display: flex
        align-items: center
        &.small
          width: 15rem
        &.black
          color: black
          font-weight: 600

        .result
          display: flex
          align-items: center
          color: #2ecc71
          svg
            height: 1.2rem

          &.red
            color: #eb2f06
            transform: translateX(-1px)

          span
            padding-left: 8px
            font-size: 14px
            font-weight: 500
</style>
